import React from "react";
import compose from "lodash/fp/compose";
import { connect } from "react-redux";
import hoistNonReactStatics from 'hoist-non-react-statics'
import {
  createAction,
  ATTACHMENT_RULE_VIEW,
  ATTACHMENT_RULE_FORM,
} from "../../../actions";
import * as attRuleActions from "../../../actions/dashboard/attachmentRule"
import { withState, withOrganisation, withDeleteConfirmation } from "..";
import { BaseHOC, withBaseHOCProps } from "../common/BaseHOC";


export const withAttachmentRule = (WrapperComponent) => {
  class AttachmentRules extends BaseHOC {
    async componentDidMount() {
      // Fetch once per store, not once per module. The previous module-level
      // `loaded` flag had two problems: assigning it triggered no re-render,
      // so the store update that arrived during `await` rendered while the
      // flag was still false and nothing re-rendered afterwards (the endless
      // spinner); and being module state it survived logout and remounts.
      const { attachmentRules, getAttachmentRules } = this.props;
      if (attachmentRules.loaded || attachmentRules.loading) return;
      try {
        await getAttachmentRules();
      } catch (e) {
        // The action already dispatches FAILURE, which clears `loading` and
        // sets `loaded`, so the page shows an error instead of spinning.
      }
    }
    deleteAttachmentRuleById = async(data) => {
      const { deleteConfirmation, deleteAttachmentRuleById } = this.props
      try {
        await deleteConfirmation.init(deleteAttachmentRuleById, data);
      } catch(e) {}
    }

    deleteBulkAttachmentRule = async (data) => {
      const { deleteBulkAttachmentRule } = this.props
      await this._deleteBulk(deleteBulkAttachmentRule, data);
    }

    render() {
      const { setValue, ...rest } = this.props;
      return (
        <WrapperComponent 
          {...rest} 
          toggleAttachmentRuleForm={setValue}
          deleteAttachmentRuleById={this.deleteAttachmentRuleById}
          deleteBulkAttachmentRule={this.deleteBulkAttachmentRule}
          loaded={this.props.attachmentRules.loaded}
          loading={this.props.attachmentRules.loading}
        />
      )
    }
  }
  const mapStateToProps = ({ 
    attachmentRules, 
    attachmentRuleForm, 
    attachmentRuleView,
  }) => {
    return ({ 
      attachmentRules,
      attachmentRuleView,
      attachmentRuleForm,
    })
  }
  const WithAttachmentRule = connect(mapStateToProps, {
    ...attRuleActions,
    toggleAttachmentRuleView: (data) => createAction(ATTACHMENT_RULE_VIEW, data),
    setValue: (data) => createAction(ATTACHMENT_RULE_FORM, data),
  })(AttachmentRules);
  hoistNonReactStatics(WithAttachmentRule, WrapperComponent)
  return compose(
    withBaseHOCProps,
    withDeleteConfirmation,
    withOrganisation, 
    withState,
  )(WithAttachmentRule);
}
